'use client'
import { createContext, useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/navigation'

const UserContext = createContext();

export function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const router = useRouter()

    const fetchUser = async () => {
        try{
            const response = await fetch('/api/auth/me')
            
            if(response.ok){
                const data = await response.json()
                setUser(data)
            }else{
                setUser(null)
            }
        }catch{
            setUser(null)
        }
    }

    const ssoLogin = async (email) => {
        try {
            const response = await fetch('/api/auth/sso/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            })

            const data = await response.json()

            if (response.ok && data.redirectUrl) {
                window.location.href = data.redirectUrl
                return { ok: true }
            }

            return { ok: false, data }
        }catch(error){
            console.error('Error during SSO login:', error)
            return {ok: false, error}
        }
    }

    const login = async (email, password) =>{
        try {
            const response = await fetch('/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ email, password }),
            })
      
            if (response.ok) {
                await fetchUser()
            }
            return {ok: response.ok}
        } catch (error) {
            console.error('Error during login:', error)
            return {ok: false, error}
        } 
    }

    const logout = async () => {
        try{
            const response = await fetch('/api/auth/logout', {
                method: 'POST',
            })

            if(response.ok){
                setUser(null)
                router.push('/login')
                return true
            }else{
                return false
            }
        }catch(error){
            console.error('Error during logout:', error)
            return false
        }
    }

    const changeAccount = async (accountId) => {
        try{
            const response = await fetch('/api/auth/account', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({accountId})
            })

            const data = await response.json()

            if(response.ok){
                await fetchUser()
                    router.push('/show/episodes')
                return true
            }
        }catch(error){
            console.error('Error during account change:', error)
            return false
        }
    }

    useEffect(() => {
        fetchUser()
    }, [])

    return (
        <UserContext.Provider value={{ user, fetchUser, login, changeAccount, logout, ssoLogin }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}

export const UserRoles = {
    0 : 'viewer',
    10 : 'commentator',
    20 : 'editor',
    30 : 'manager',
    40 : 'admin'
}

export function UserRole({children, role = 'viewer'}){
    const {user} = useUser()
    const roles = {
        'viewer' : 0,
        'commentator' : 10,
        'editor' : 20,
        'manager' : 30,
        'admin' : 40
    }
    if(user && user.role >= roles[role]){
        return children
    }
    return null
}

export function UserOwns({children, id}){
    const {user} = useUser()
    if(user && user.id === id){
        return children
    }else{
        return null
    }
}
